import { Trans } from "react-i18next";
import { Modal, ModalContent, ModalTitle, useMuiModal } from "./modal";
import { Button } from "./ui/button";
import { useAudioSlot } from "@/features/audio/kiosk-audio";

export function NotAvailableInOfflineModeModal() {
  useAudioSlot("modal.offline");
  const { closeModal } = useMuiModal();
  return (
    <Modal>
      <ModalTitle>
        <Trans>Nem elérhető offline módban</Trans>
      </ModalTitle>
      <ModalContent>
        <p>
          <Trans>
            Az internetkapcsolat megszakadt, ezért ez a funkció jelenleg nem
            elérhető.
          </Trans>
        </p>
        <Button onClick={closeModal}>
          <Trans>Rendben</Trans>
        </Button>
      </ModalContent>
    </Modal>
  );
}
